if (window.location.pathname.includes("apps/customer-portal")) {
  setTimeout(()=>{
    const menuSections = document.querySelectorAll(".bss-menu-navigation-section");

  if (menuSections.length >= 2) {
    const secondMenuSection = menuSections[menuSections.length-3]; 

    const newMenuSection = document.createElement("div");
    newMenuSection.classList.add("bss-menu-navigation-section");
    const menuItems = [
      { name: "Retailer Agreement", link: "/pages/retailer-agreement" },
      { name: "Certifications and Insurance", link: "/pages/certifications-and-insurance" },
      { name: "Catalogs and Marketing", link: "/pages/marketing-materials" },
    ];

    const menuContent = document.createElement("div");
    menuContent.classList.add("Polaris-Box");
    menuContent.style.cssText =
      "--pc-box-padding-block-end-xs: var(--p-space-5); --pc-box-padding-block-start-xs: var(--p-space-5); --pc-box-padding-inline-start-xs: var(--p-space-8); --pc-box-padding-inline-end-xs: var(--p-space-8); --pc-box-width: 100%;";

    const menuStack = document.createElement("div");
    menuStack.classList.add("Polaris-VerticalStack");
    menuStack.style.cssText =
      "--pc-vertical-stack-order: column; --pc-vertical-stack-gap-xs: var(--p-space-2);";

    menuItems.forEach((item) => {
      const menuItem = document.createElement("div");
      menuItem.classList.add("bss-menu-navigation-section-btn");

      menuItem.innerHTML = `
        <div class="Polaris-HorizontalStack" style="--pc-horizontal-stack-align: space-between; --pc-horizontal-stack-wrap: wrap;">
          <div class="Polaris-HorizontalStack" style="--pc-horizontal-stack-wrap: wrap; --pc-horizontal-stack-gap-xs: var(--p-space-2);">
            <a href="${item.link}" class="Polaris-Text--root Polaris-Text--bodyMd" style="text-decoration: none; color: inherit;">
              ${item.name}
            </a>
          </div>
        </div>
      `;

      menuStack.appendChild(menuItem);
    });

    menuContent.appendChild(menuStack);
    newMenuSection.appendChild(menuContent);
    secondMenuSection.insertAdjacentElement("beforeend", newMenuSection);
  }
  },3000)
}

setTimeout(() => {
  window.dispatchEvent(new Event("scroll"));
  const elements = document.querySelectorAll('.hiddenPrice');
  elements.forEach(ele => {
    ele.classList.remove('hiddenPrice');
  })
}, 5000);